"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Utilities = void 0;
var Buffer = require('buffer/').Buffer;
var libsodium_wrappers_1 = __importDefault(require("libsodium-wrappers"));
var bs58_1 = __importDefault(require("bs58"));
var crypto_1 = __importDefault(require("crypto"));
var Utilities = /** @class */ (function () {
    function Utilities() {
    }
    Utilities.randomString = function (_a) {
        var 
        // The base for this function can be found here:
        // https://stackoverflow.com/questions/1349404/generate-random-string-characters-in-javascript
        length = _a.length, _b = _a.useLowerCase, useLowerCase = _b === void 0 ? true : _b, _c = _a.useUpperCase, useUpperCase = _c === void 0 ? true : _c, _d = _a.useDigits, useDigits = _d === void 0 ? true : _d;
        var result = '';
        var chars = '';
        // We removed similar characters, e.g. 0 (zero) and O (capital o)
        chars = chars.concat("" + (useUpperCase ? 'ABCDEFGHIJKLMNPQRSTUVWXYZ' : ''), "" + (useLowerCase ? 'abcdefghijkmnopqrstuvwxyz' : ''), "" + (useDigits ? '23456789' : ''));
        for (var i = 0; i < length; i++) {
            result += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return result;
    };
    Utilities.randomBytes = function (numBytes) {
        return __awaiter(this, void 0, void 0, function () {
            var sodium;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!numBytes || numBytes === 0)
                            return [2 /*return*/, Buffer.from('')];
                        return [4 /*yield*/, Utilities.libsodium()];
                    case 1:
                        sodium = _a.sent();
                        return [2 /*return*/, sodium.randombytes_buf(numBytes)];
                }
            });
        });
    };
    Utilities.uniqueId = function () {
        var timeInMs = new Date().getTime();
        var timeInMsHex = timeInMs.toString(16);
        var timeinMsBuffer = Buffer.from(timeInMsHex, 'hex');
        var payload = new Uint8Array(15);
        if (typeof window === 'undefined') {
            payload = crypto_1.default.pseudoRandomBytes(15);
        }
        else {
            payload = window.crypto.getRandomValues(payload);
        }
        var value = Buffer.concat([timeinMsBuffer, payload]);
        var id = bs58_1.default.encode(value);
        return id;
    };
    Utilities.simpleId = function () {
        return "" + new Date().getTime().toString(36) + Math.floor(100000000000000 + Math.random() * 900000000000000).toString(36);
    };
    Utilities.saltedPassword = function (_a) {
        var password = _a.password;
        return __awaiter(this, void 0, void 0, function () {
            var sodium, saltedPassword;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Utilities.libsodium()];
                    case 1:
                        sodium = _b.sent();
                        saltedPassword = sodium.crypto_pwhash_str(password, sodium.crypto_pwhash_OPSLIMIT_INTERACTIVE, sodium.crypto_pwhash_MEMLIMIT_INTERACTIVE);
                        return [2 /*return*/, saltedPassword];
                }
            });
        });
    };
    Utilities.verifyPassword = function (_a) {
        var saltedPassword = _a.saltedPassword, plainPassword = _a.plainPassword;
        return __awaiter(this, void 0, void 0, function () {
            var sodium, result;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Utilities.libsodium()];
                    case 1:
                        sodium = _b.sent();
                        result = sodium.crypto_pwhash_str_verify(saltedPassword, plainPassword);
                        return [2 /*return*/, result];
                }
            });
        });
    };
    Utilities.digest = function (_a) {
        var length = _a.length, data = _a.data;
        return __awaiter(this, void 0, void 0, function () {
            var sodium;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Utilities.libsodium()];
                    case 1:
                        sodium = _b.sent();
                        return [2 /*return*/, new Promise(function (resolve) {
                                resolve(new Uint8Array(sodium.crypto_generichash(length, Buffer.from(data))));
                            })];
                }
            });
        });
    };
    Utilities.base58 = function (_a) {
        var data = _a.data;
        return bs58_1.default.encode(Buffer.from(data));
    };
    Utilities.libsodium = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!Utilities.sodium) return [3 /*break*/, 2];
                        Utilities.sodium = libsodium_wrappers_1.default;
                        return [4 /*yield*/, Utilities.sodium.ready];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/, Utilities.sodium];
                }
            });
        });
    };
    Utilities.secretBoxEncrypt = function (_a) {
        var nonce = _a.nonce, message = _a.message, secret = _a.secret;
        return __awaiter(this, void 0, void 0, function () {
            var sodium;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Utilities.libsodium()];
                    case 1:
                        sodium = _b.sent();
                        return [2 /*return*/, sodium.crypto_secretbox_easy(message, nonce, secret)];
                }
            });
        });
    };
    Utilities.secretBoxDecrypt = function (_a) {
        var nonce = _a.nonce, box = _a.box, secret = _a.secret;
        return __awaiter(this, void 0, void 0, function () {
            var sodium;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Utilities.libsodium()];
                    case 1:
                        sodium = _b.sent();
                        return [2 /*return*/, sodium.crypto_secretbox_open_easy(box, nonce, secret)];
                }
            });
        });
    };
    return Utilities;
}());
exports.Utilities = Utilities;
